import {Injectable} from '@angular/core';
import {Car} from "../../models/entities/car";
import {ApiService} from "@eclick/core-v2";

@Injectable({
  providedIn: 'root'
})
export class CarService {

  carList: Car[] = [];

  constructor(private api: ApiService) {
  }

  set cars(cars: Car[]) {
    this.carList = cars;
  }

  get cars() {
    return this.carList;
  }

  getCarBySlug(slug: string) {
    return this.carList.find(car => car.slug === slug);
  }
}
